import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { FacadeService } from 'src/app/services/FacadeService';
import { Project, ProjectView, User } from 'src/models';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-project-dialog',
  templateUrl: './project-dialog.component.html',
  styleUrls: ['./project-dialog.component.less']
})
export class ProjectDialogComponent implements OnInit {
  project: Project;
  showSpinner: boolean;
  buttonText: string;
  errorMessage: string;
  showError: boolean;
  user$: Observable<User>;
  user: User;
  duplicateNameFound: boolean;

  constructor(
    public dialogRef: MatDialogRef<ProjectDialogComponent>,    
    private service: FacadeService,
    private store: Store<{user: User}>,
    @Inject(MAT_DIALOG_DATA) public data: {Project: Project, View: ProjectView}) {}

  ngOnInit() {
    this.project = this.data.Project;
    this.user$ = this.store.select('user');

    if(this.project.isQuote && this.data.View === ProjectView.Save) {
      this.project.quoteNumber = this.project.projectName;
      this.project.projectName = '';
    }

    this.user$.subscribe(x => {
      this.user = x;      
    });
            
    switch(this.data.View) {
      case ProjectView.Save:
        this.buttonText = 'Save';
        break;
      case ProjectView.Copy:
        this.buttonText = "Save Copy";
        break;
      case ProjectView.SaveAndDownload:
      case ProjectView.SaveAndZip:
        this.buttonText = "Download Project";
        break;
      case ProjectView.SaveAndEmail:
        this.buttonText = "Email Project";
        break;
      default:
        this.buttonText = "Not Mapped";
    }
  }

  onSave(): void {
    if(this.showSpinner) return;

    if(!this.project.projectName){
      this.showError = true;
      return;
    }

    this.showSpinner = true;
    
    if(this.project.isQuote && !(this.data.View === ProjectView.Save)) {      
      switch(this.data.View) {        
        case ProjectView.SaveAndZip:
          this.onDownloadZip(this.project);
          break;
        case ProjectView.SaveAndDownload:
          this.onDownloadPdf(this.project);
          break;
        case ProjectView.SaveAndEmail:
          this.onEmailPdf(this.project);
          break;
        default:
          this.errorMessage = 'There was a problem processing your request. Please try again.';
          this.showSpinner = false;
        break;
      }
    } else {
      this.service.productService.SaveProject({...this.project, ...{customerNo: this.user.navCustomerNo}}).then((x : any)=> {      
        if(x.success){
          const {project} = x;
          switch(this.data.View) {
              case ProjectView.Save:      
              case ProjectView.Copy:
                this.dialogRef.close(x);
                break;
              case ProjectView.SaveAndZip:
                this.onDownloadZip(project);
                break;
              case ProjectView.SaveAndDownload:
                this.onDownloadPdf(project);
                break;
              case ProjectView.SaveAndEmail:
                  this.onEmailPdf(project);
                  break;
              default:
                this.errorMessage = 'There was a problem processing your request. Please try again.';
                this.showSpinner = false;
              break;
          }
        }else {          
          this.errorMessage = x.errorMessage;
          this.showSpinner = false;

          if(x.duplicateNameFound){
            this.duplicateNameFound = true;
            this.showError = true;
          }          
        }      
      }); 
    }    
  }

  onDownloadPdf(project) {    
    this.showSpinner = true;
    this.service.productService.GetPdf(project).then((data: Blob) => {    
       
      if(data.size < 150) {
        this.errorMessage = "There was a problem generating your report.";
        this.showSpinner = false;
        return;
      }
      var file = new Blob([data], { type: data.type })
      var fileURL = URL.createObjectURL(file);

      // if you want to open PDF in new tab
      window.open(fileURL); 
      var a         = document.createElement('a');
      a.href        = fileURL; 
      a.target      = '_blank';
      a.download    = `${project.projectName}.pdf`;
      document.body.appendChild(a);
      a.click();

      project.products = project.products.filter(x => !x.isTrackItem);
      const result = {success: true, project: project};
      this.dialogRef.close(result);
    });
  }

  onDownloadZip(project) {
    this.showSpinner = true;
    this.service.productService.GetZip(project).then((data: Blob) => {
      var file = new Blob([data], { type: data.type })
      var fileURL = URL.createObjectURL(file);

      var a         = document.createElement('a');
      a.href        = fileURL;       
      a.download    = `${project.projectName}.zip`;
      document.body.appendChild(a);
      a.click();

      project.products = project.products.filter(x => !x.isTrackItem);
      const result = {success: true, project: project};
      this.dialogRef.close(result);
    });
  }

  onEmailPdf(project) {    
    this.showSpinner = true;
    this.service.productService.SendPdf(project).then((data: any) => {    
      if(data.emailAddress) {
        project.products = project.products.filter(x => !x.isTrackItem);
        const result = {success: true, project: project, emailAddress: data.emailAddress};
        this.dialogRef.close(result);

      } else {
        this.errorMessage = "There was a problem generating your report.";
        this.showSpinner = false;
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
